// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"ActivitiesSection_sectionWrapper__Mwxg1","cardsWrapper":"ActivitiesSection_cardsWrapper__EKb00"};